module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IC-e401243fa5c6d3b5f2d44cff1a0412a6.png";